<!-- Text Skeleton -->
<ng-container *ngIf="type === 'text'">
  <div *ngFor="let item of items" class="skeleton skeleton--text" [style.width]="width" [style.height]="height"></div>
</ng-container>

<!-- Circle Skeleton -->
<ng-container *ngIf="type === 'circle'">
  <div *ngFor="let item of items" class="skeleton skeleton--circle" [style.width]="width || '48px'" [style.height]="height || '48px'"></div>
</ng-container>

<!-- Rectangle Skeleton -->
<ng-container *ngIf="type === 'rectangle'">
  <div *ngFor="let item of items" class="skeleton skeleton--rectangle" [style.width]="width" [style.height]="height"></div>
</ng-container>

<!-- Card Skeleton -->
<ng-container *ngIf="type === 'card'">
  <div *ngFor="let item of items" class="skeleton-card">
    <div class="skeleton skeleton--rectangle skeleton-card__header"></div>
    <div class="skeleton-card__body">
      <div class="skeleton skeleton--text skeleton-card__title"></div>
      <div class="skeleton skeleton--text skeleton-card__subtitle"></div>
      <div class="skeleton skeleton--text skeleton-card__text"></div>
      <div class="skeleton skeleton--text skeleton-card__text" style="width: 80%;"></div>
    </div>
  </div>
</ng-container>

<!-- Table Skeleton -->
<ng-container *ngIf="type === 'table'">
  <div class="skeleton-table">
    <!-- Header -->
    <div class="skeleton-table__header">
      <div class="skeleton skeleton--text" style="width: 20%;"></div>
      <div class="skeleton skeleton--text" style="width: 30%;"></div>
      <div class="skeleton skeleton--text" style="width: 25%;"></div>
      <div class="skeleton skeleton--text" style="width: 15%;"></div>
      <div class="skeleton skeleton--text" style="width: 10%;"></div>
    </div>
    <!-- Rows -->
    <div *ngFor="let row of rowItems" class="skeleton-table__row">
      <div class="skeleton skeleton--text" style="width: 20%;"></div>
      <div class="skeleton skeleton--text" style="width: 30%;"></div>
      <div class="skeleton skeleton--text" style="width: 25%;"></div>
      <div class="skeleton skeleton--text" style="width: 15%;"></div>
      <div class="skeleton skeleton--text" style="width: 10%;"></div>
    </div>
  </div>
</ng-container>

<!-- List Skeleton -->
<ng-container *ngIf="type === 'list'">
  <div class="skeleton-list">
    <div *ngFor="let item of rowItems" class="skeleton-list__item">
      <div class="skeleton skeleton--circle" style="width: 40px; height: 40px;"></div>
      <div class="skeleton-list__content">
        <div class="skeleton skeleton--text" style="width: 70%;"></div>
        <div class="skeleton skeleton--text" style="width: 50%;"></div>
      </div>
    </div>
  </div>
</ng-container>
